import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PathDrawing from "./LandingAnimation";
import "./LandingTitle.css";

const LandingTitle = () => {
    
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1000); // Mobile breakpoint at 1000px
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const graphParams = {
        width: 400,
        height: 400
    }
    
    return (
        <div className="landingTitle">
            <div className="content row">
                <div className="col text">
                    <h1>Upgrade Your EMS Quality Workflow Today</h1>
                    
                    <button className="demo-btn" onClick={() => navigate('/demo')}>
                        Try our interactive demo
                        <i className="fa-solid fa-chevron-right"></i>
                    </button>
                    
                </div>
                {!isMobile && (
                    <div className="col graphs">
                        <PathDrawing/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LandingTitle;